export const common = {
  download: 'Letöltés',
  loading: 'Betöltés...',
  save: 'Mentés',
  saving: 'Mentés...',
  cancel: 'Mégse',
  edit: 'Szerkesztés',
  delete: 'Törlés',
  create: 'Létrehozás',
  creating: 'Létrehozás...',
  update: 'Frissítés',
  updating: 'Frissítés...',
  search: 'Keresés...',
  logout: 'Kijelentkezés',
  close: 'Bezárás',
  copy: 'Másolás',
  copied: 'Másolva',
  copyFailed: 'Másolás sikertelen',
  noData: 'Nincs megjeleníthető adat',
  error: 'Hiba',
  reload: 'Újratöltés',
  refresh: 'Frissítés',
  select_language: 'Nyelv kiválasztása',
  dateFilter: 'Szűrés dátum szerint',
  showing: 'Megjelenítve {{count}} bejegyzés',
  exportExcel: 'Exportálás Excelbe',
  inDevelopment: 'Fejlesztés alatt',
  whatsNew: 'Legújabb újítások',
  version: 'Verzió',
  yes: 'Igen',
  no: 'Nem',
  active: 'Aktív',
  inactive: 'Inaktív',
  invalidDate: 'Érvénytelen dátum',
  all: 'Összes',
  status: 'Státusz',
  approve: 'Jóváhagyás',
  approved: 'Jóváhagyva',
  optional: 'opcionális',
  errors: {
    loadingFailed: 'Az adatok betöltése sikertelen. Kérjük, próbálja újra.',
    saveFailed: 'A mentés sikertelen. Kérjük, próbálja újra.',
    pageNotFound: {
      title: 'Az oldal nem található',
      description: 'A keresett oldal nem létezik vagy áthelyezték. Ellenőrizze az URL-t, vagy térjen vissza a főoldalra.',
      quickLinks: 'Gyakori oldalak:'
    }
  },
  validation: {
    required: 'Ez a mező kötelező'
  },
  modules: {
    enabled: 'Engedélyezett modul',
    disabled: 'Letiltott modul', 
    premium: 'Prémium funkció',
    status: 'Modul státusz'
  },
  actions: 'Műveletek',
  tableView: 'Táblázatos nézet',
  cardView: 'Kártyás nézet',
  view: 'Megtekintés',
  actionsObject: {
    edit: 'Szerkesztés',
    save: 'Mentés',
    cancel: 'Mégse',
    delete: 'Törlés',
    create: 'Létrehozás',
    view: 'Megtekintés',
    close: 'Bezárás',
    share: 'Megosztás',
    refresh: 'Frissítés'
  },
  buttons: {
    save: 'Mentés',
    cancel: 'Mégse',
    create: 'Létrehozás',
    edit: 'Szerkesztés',
    delete: 'Törlés',
    close: 'Bezárás',
    submit: 'Küldés',
    update: 'Frissítés',
    view: 'Megtekintés',
    back: 'Vissza',
    backToBuilder: 'Vissza a Form Builder-hez',
    next: 'Tovább',
    previous: 'Előző',
    add: 'Hozzáadás',
    remove: 'Eltávolítás',
    confirm: 'Megerősítés',
    retry: 'Újrapróbálkozás'
  },
  confirmDelete: 'Biztosan törölni szeretné ezt az elemet?',
  profile: {
    title: 'Profil beállítások',
    subtitle: 'Személyes és szervezeti adatok kezelése',
    personalInfo: 'Személyes adatok',
    fullName: 'Teljes név',
    email: 'Email cím',
    phone: 'Telefonszám',
    organization: 'Szervezeti adatok',
    organizationName: 'Szervezet neve',
    taxNumber: 'Adószám',
    registrationNumber: 'Cégjegyzékszám',
    organizationStatus: 'Szervezet státusza',
    changePassword: 'Jelszó módosítása',
    currentPassword: 'Jelenlegi jelszó',
    newPassword: 'Új jelszó',
    confirmPassword: 'Új jelszó megerősítése',
    updatePassword: 'Jelszó módosítása'
  },
  messages: {
    profile: {
      updateSuccess: 'A profil sikeresen frissítve',
      updateError: 'Hiba történt a profil frissítése közben',
      passwordMismatch: 'A megadott jelszavak nem egyeznek',
      passwordChangeSuccess: 'A jelszó sikeresen módosítva',
      passwordChangeError: 'Hiba történt a jelszó módosítása közben',
      passwordTooShort: 'A jelszónak legalább 6 karakter hosszúnak kell lennie',
      wrongPassword: 'A jelenlegi jelszó helytelen',
      weakPassword: 'A jelszó túl gyenge'
    },
    linkCopied: 'Link másolva a vágólapra',
    shareError: 'Hiba történt a link megosztása közben',
    authContext: {
      error: 'Hiba történt a felhasználó adatok betöltése közben',
      signInSuccess: 'Sikeres bejelentkezés!',
      signInError: 'Sikertelen bejelentkezés',
      signOutSuccess: 'Sikeres kijelentkezés!',
      signOutError: 'Sikertelen kijelentkezés',
      invalidCredentials: 'Hibás e-mail cím vagy jelszó',
      userDisabled: 'Ez a felhasználói fiók le van tiltva',
      tooManyRequests: 'Túl sok sikertelen próbálkozás. Kérjük, próbálja újra később',
      accountDeactivated: 'A hozzáférésed le van tiltva. Kérjük, vedd fel a kapcsolatot az ügyfélszolgálattal.'
    },
    customer: {
      failedToLoad: 'Hiba történt a ügyfelek betöltése közben',
      createdSuccess: 'Ügyfél sikeresen létrehozva',
      createdError: 'Hiba történt a ügyfél létrehozása közben',
      updatedSuccess: 'Ügyfél sikeresen frissítve',
      updatedError: 'Hiba történt a ügyfél frissítése közben',
      deletedSuccess: 'Ügyfél sikeresen törölve',
      deletedError: 'Hiba történt a ügyfél törlése közben',

      customerStatusUpdated: 'Ügyfél státusza frissítve:  ',
      customerStatusUpdateFailed: 'Hiba történt a ügyfél státusz frissítése közben'
    },
    quotation: {
      createSuccess: 'Árajánlat sikeresen létrehozva',
      createError: 'Hiba történt a árajánlat létrehozása közben',
      offerStatusUpdated: 'Árajánlat státusza frissítve:  ',
      offerStatusUpdateFailed: 'Hiba történt a árajánlat státusz frissítése közben',
      updateStatus: "Kattints a státusz módosításához"
    },
    organization: {
      emailNotFound: 'Nem található felhasználó ezzel az email címmel',
      userAlreadyExists: 'Ez a felhasználó már tagja ennek a szervezetnek',
      userAdded: 'Felhasználó sikeresen hozzáadva',
      userInvited: 'Felhasználó sikeresen meghívva',
      userAddError: 'Hiba történt a felhasználó hozzáadása közben',
      userRemoved: 'Felhasználó sikeresen eltávolítva',
      userRemoveError: 'Hiba történt a felhasználó eltávolítása közben',

      createdSuccess: 'Szervezet sikeresen létrehozva',
      createdError: 'Hiba történt a szervezet létrehozása közben',
      updateSuccess: 'Szervezet sikeresen frissítve',
      updateError: 'Hiba történt a szervezet frissítése közben',
      deleteSuccess: 'Szervezet sikeresen törölve',
      deleteError: 'Hiba történt a szervezet törlése közben',

      logoUploadSuccess: 'Logó sikeresen feltöltve',
      logoUploadError: 'Hiba történt a logó feltöltése közben',
      logoDeleteSuccess: 'Logó sikeresen eltávolítva',
      logoDeleteError: 'Hiba történt a logó eltávolítása közben',
    },
    copyError: 'Hiba történt a link másolása közben',
    documentGenerationStarted: 'Dokumentum generálás elindítva:'
  },
  placeholders: {
    selectOrg: 'Válasszon szervezetet...',
    selectOrganization: 'Válasszon szervezetet...',
    selectCustomer: 'Válasszon ügyfelet...',
    selectProduct: 'Válasszon terméket...',
    selectQuotation: 'Válasszon árajánlatot...',
    notes: 'További megjegyzések az árajánlathoz...',
    itemNotes: 'Megjegyzés ehhez a tételhez...',
    quotationNotes: 'Általános megjegyzések az árajánlathoz...',
    email: 'Email cím...',
    unitPlaceholder: 'pl.: darab, óra, nap',
    deals: "Keresés ügyletekben (leírás, tárgy, ügyfél, felelős)..."
  },
  page: {
    notFound: 'Oldal nem található',
    returnToDashboard: 'Vissza a vezérlőpultra'
  },
  settings: {
    title: 'Beállítások',
    subtitle: 'Rendszer beállítások és konfiguráció',
    organizations: 'Szervezetek',
    notifications: {
      title: 'Értesítési beállítások',
      subtitle: 'Testreszabja az értesítési beállításokat',
      emailNotifications: 'Email értesítések',
      emailDescription: 'Válassza ki, milyen esetekben szeretne email értesítést kapni',
      inAppNotifications: 'Alkalmazáson belüli értesítések',
      inAppDescription: 'Válassza ki, milyen értesítéseket szeretne látni az alkalmazásban',
      otherSettings: 'Egyéb beállítások',
      otherDescription: 'Hangjelzés, asztali értesítések és egyéb beállítások',
      quietHours: 'Csendes órák',
      quietHoursDesc: 'Állítsa be azokat az órákat, amikor nem szeretne értesítéseket kapni',
      taskAssignedDesc: 'Értesítés, amikor feladatot rendelnek hozzá',
      taskCompletedDesc: 'Értesítés, amikor feladatot befejeznek',
      taskOverdueDesc: 'Értesítés, amikor feladat lejár',
      projectUpdateDesc: 'Értesítés projekt frissítésekről',
      deadlineReminderDesc: 'Értesítés közelgő határidőkről',
      systemDesc: 'Rendszer értesítések és hírek',
      soundEnabled: 'Hang engedélyezése',
      soundEnabledDesc: 'Hang lejátszása új értesítés érkezésekor',
      desktopNotifications: 'Asztali értesítések',
      desktopNotificationsDesc: 'Böngésző értesítések megjelenítése',
      enableQuietHours: 'Csendes órák engedélyezése',
      startTime: 'Kezdés ideje',
      endTime: 'Befejezés ideje',
      saveSuccess: 'Beállítások sikeresen mentve',
      saveError: 'Hiba történt a beállítások mentése közben',
      loadError: 'Hiba történt a beállítások betöltése közben'
    }
  },
  pagination: {
    showing: 'Megjelenítve',
    itemsPerPage: 'db/oldal',
    of: 'összesen',
    to: 'a',
    results: 'eredmény'
  },
  accept: 'Elfogadás',
  deny: 'Elutasítás',
  add: 'Hozzáadás',
  remove: 'Eltávolítás',
  uploading: 'Feltöltés...',
  modifiedBy: 'Módosította',
  submit: 'Küldés',
  submitting: 'Küldés folyamatban...',
  createdAt: 'Létrehozva',
  updatedAt: 'Frissítve',
  createdBy: 'Létrehozó',
  filters: 'Szűrők',
  reset: 'Alaphelyzet',
  readOnlyMode: 'Csak olvasható nézet',
  shortcuts: {
    ctrlEnter: 'Ctrl+Enter a mentéshez'
  },
  back: 'Vissza',
  backToHome: 'Vissza a főoldalra',
  backToPortal: 'Vissza a portálra',
  nav: {
    customers: 'Ügyfelek',
    projects: 'Projektek', 
    deals: 'Üzletek',
    tasks: 'Feladatok'
  }
};